import PreferenceLevel from "./PreferenceLevel.jsx";
import { useTranslation } from 'react-i18next';


const activities = [

    ["swimming", "Natación"],
    ["snorkel", "Snorkel"],
    ["diving", "Buceo"],
    ["jetSki", "Moto acuática"],
    ["fishing", "Pesca"],
    ["reading", "Lectura"],
    ["sunbathing", "Tomar el sol"],
    ["beaches", "Playas"],
    ["shopping", "Compras"],
    ["nightlife", "Vida nocturna"],
    ["other", "Otros"]

];

export default function ActivitiesSection({
    data,
    onActivityChange,
    onOtherActivitiesChange,
    lang
}) {

    const { t } = useTranslation();

    return (

        <>
            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Actividades")}</h2>

            <table className="preferences-table t-align-center" style={{ marginLeft: "auto", marginRight: "auto", width: "85%" }}>

                <thead>

                    <tr>

                        <th className="u-align-center fontmontserrat" style={{ width: "60%" }}>{t("Actividad")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Bajo")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Medio")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Alto")}</th>

                    </tr>

                </thead>

                <tbody>

                    {activities.map(([key, label]) => (

                        <PreferenceLevel
                            key={key}
                            label={label}
                            value={data[key]}
                            onChange={(value) =>
                                onActivityChange(key, value)
                            }
                        />

                    ))}

                </tbody>

            </table>
            <p className="u-align-center fontmontserrat" style={{ marginLeft: "30px" }}>{t("Nota: El buceo solo está permitido para personas certificadas o acompañadas por instructores profesionales. Algunas actividades pueden requerir un coste adicional.")}</p>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="otheractivities" className="u-form-control-hidden u-label fontmontserrat">{t("Otras actividades de interés")}</label>
                <textarea
                    rows="4"
                    value={data.otherActivities}
                    onChange={(e) =>
                        onOtherActivitiesChange(e.target.value)
                    }
                    required
                    placeholder={t("Otras actividades de interés")}
                    id="otheractivities"
                    name="otheractivities"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>
        </>

    );

}
